import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { LabelType } from "__generated__/enums";
import { GetLabelsByTypeQuery, GetLabelsByTypeDocument } from "__generated__/view/labels/graphql/queries.generated";
import { ChildPropsFromArray } from "types/commons";

export type LabelSelectOption = ChildPropsFromArray<GetLabelsByTypeQuery, "labels">

const LabelSelect = <Multiple extends boolean = false,>({
	type,
	...rest
}: Omit<SelectProps<LabelSelectOption, Multiple>, "fetchOptions"> & { type: LabelType }) => {

	const client = useApolloClient();

	const onFetchOptions = async() => {

		try  {
			const result = await client.query({
				query: GetLabelsByTypeDocument,
				variables: {
					type: type,
				},
			});

			const options = (result.data.labels || []) as LabelSelectOption[];

			return {
				options: options,
				totalResults: options.length,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => option.text}
			getOptionColor={(option) => option.color} />
	);
};

export default LabelSelect;
